import React from 'react';
import { authRoutes } from './auth';
import { bookRoutes } from './books';
import { orderRoutes } from './orders';
import { flattenRoutes, IRoute } from './utils';

const allRoutes = [
  ...authRoutes,
  ...orderRoutes,
  ...bookRoutes
];
const allFlattenRoutes = flattenRoutes(allRoutes);

export { allRoutes, allFlattenRoutes };